export default "__VITE_ASSET__BXKNk7p1__"